module.exports = new __parcel__URL__("jpd-try-end-learn.5d9c30dc.svg").toString();